import React from 'react'
import {MuiPickersUtilsProvider} from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'

function PickersProvider(props) {
  return <MuiPickersUtilsProvider utils={MomentUtils}>{props.children}</MuiPickersUtilsProvider>
}

export default PickersProvider
